import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { TransportOrderIdView } from '../../../../models';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { Observable } from 'rxjs';
import { ShipmentTransportOrderOverview } from '../../models/shipment-transport-order.model';
import { ShipmentTransportOrderMainInfoState } from './shipment-transport-order-main-info.state';
import {
  ShipmentTransportOrderOverviewLoad,
  ShipmentTransportOrderOverviewSetInitialState,
} from './shipment-transport-order-main-info.actions';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderMainInfoFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(ShipmentTransportOrderMainInfoState.getLoaded);
  mainInfo$: Observable<ShipmentTransportOrderOverview> = this.store.select(
    ShipmentTransportOrderMainInfoState.getOverview,
  );

  constructor(private store: Store) {}

  loadAll(identifier: TransportOrderIdView): void {
    this.store.dispatch(new ShipmentTransportOrderOverviewLoad(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentTransportOrderOverviewSetInitialState());
  }
}
